import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';

type LineUser = {
  line_id: string;
  staffID?: number;
  guardianID?: number;
};

// 招待トークンを元にLineユーザーを紐付ける
export const attachLineUser = async (
  token: string,
  lineID: string
): Promise<ApiResult<LineUser>> => {
  const { status, result } = await callApiWithoutToken<LineUser>(
    `line/invite`,
    'POST',
    undefined,
    undefined,
    {
      line_id: lineID,
      token: token,
    }
  );
  return { status, result };
};
